export default "__VITE_ASSET__CoOdul8S__"